import { LOCAL_STORAGE_KEYS } from 'ts/constants/local-storage-keys';
import type { IMessageEvent } from 'ts/interfaces/common/events';
import type { ApiFile } from 'ts/types/file';

export const DocumentsStorage = {
  getDataToEvent: (): IMessageEvent | ApiFile | null => {
    const data = localStorage.getItem(LOCAL_STORAGE_KEYS.DATA_TO_EVENT);

    return data ? JSON.parse(data) : null;
  },
  setDataToEvent: (data: IMessageEvent | ApiFile) => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.DATA_TO_EVENT, JSON.stringify(data));
  }
};
